import classNames from 'classnames';
import { Button } from '~/components/common/button';
import { Section } from '~/components/common/section';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import { Translate } from '~/i18n';
import { useState } from 'react';
import { useAccountStatus } from '~/auth';
import { AccountStatuses } from '~/auth/use-account-status';
import cn from 'classnames';

type FormSectionProps = {
   note?: React.ReactNode;
   title: React.ReactNode;
   children: React.ReactNode;
   cancelBtnTitle?: React.ReactNode;
   fwdBtnTitle: React.ReactNode;
   fwdBtnHandler?: () => void;
   cancelBtnHandler?: any;
   formClassName?: string;
   description?: React.ReactNode;
   sectionClassName?: string;
   footerClassName?: string;
   loading?: boolean;
   disableSubmit?: boolean;
};

let timeout: any;

const FormSection = ({
   note,
   title,
   children,
   cancelBtnTitle,
   fwdBtnTitle,
   fwdBtnHandler,
   formClassName,
   description,
   sectionClassName,
   footerClassName,
   loading,
   disableSubmit,
   cancelBtnHandler,
}: FormSectionProps) => {
   const [showPopover, setShow] = useState(false);
   const { status } = useAccountStatus();
   const underReview = status === AccountStatuses.UnderReview;

   const openPopover = () => {
      clearTimeout(timeout);
      setShow(true);
      timeout = setTimeout(() => setShow(false), 5000);
   };

   const handleSubmitAction = (e: any) => {
      if (underReview) {
         e.preventDefault();
         openPopover();
      } else {
         fwdBtnHandler?.();
      }
   };

   return (
      <div>
         <Section
            className={classNames(
               sectionClassName && sectionClassName,
               'lg:py-11 lg:px-14 py-6 px-4'
            )}>
            {note ? (
               <div className="px-6 py-3 mb-8 text-xs text-yellow-500 bg-yellow-100 lg:w-1/2 p md:text-sm rounded-default">
                  {note}.
               </div>
            ) : null}
            {title ? (
               <span className="flex-1 mb-6 text-xl font-bold text-black sm:text-3xl">{title}</span>
            ) : null}
            {description && <div className="text-xs text-gray-500 md:text-sm">{description}</div>}
            <div className="mt-10">
               <div className={classNames(formClassName && formClassName, 'xl:w-1/2')}>
                  {children}
               </div>
               <div
                  className={classNames(
                     footerClassName && footerClassName,
                     'flex mt-8 space-x-2 md:space-x-4 rtl:space-x-reverse'
                  )}>
                  {cancelBtnTitle ? (
                     <Button
                        onClick={() => cancelBtnHandler?.()}
                        disabled={loading || !cancelBtnHandler}
                        theme="secondary"
                        className="h-12 !px-6">
                        {cancelBtnTitle}
                     </Button>
                  ) : null}
                  <Popover
                     isOpen={showPopover}
                     positions={['top']}
                     padding={15}
                     containerClassName="z-30"
                     onClickOutside={() => setShow(false)}
                     content={({ position, childRect, popoverRect }) => (
                        <div>
                           <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                              position={position}
                              childRect={childRect}
                              popoverRect={popoverRect}
                              arrowColor="white"
                              arrowSize={10}
                              className="popover-arrow-container"
                              arrowClassName="popover-arrow">
                              <div
                                 className="px-6 py-5 bg-white rounded-default"
                                 style={{ boxShadow: '0px 4px 72px rgba(0, 0, 0, 0.12)' }}>
                                 <Translate id="profile:your account is under review popover" />
                              </div>
                           </ArrowContainer>
                        </div>
                     )}>
                     <Button
                        disabled={loading || disableSubmit}
                        loading={loading}
                        onClick={handleSubmitAction}
                        type="submit"
                        theme="primary"
                        className={cn('h-12 !px-6', underReview && 'disabled')}>
                        {fwdBtnTitle}
                     </Button>
                  </Popover>
               </div>
            </div>
         </Section>
      </div>
   );
};

export default FormSection;
